// @flow

import conf from 'client/conf';
import { createInstance } from '@optimizely/optimizely-sdk';

type EnabledFeaturesType = {
  attributes?: {
    [string]: string | number | boolean,
  },
  userId: string,
};

type EnabledFeatureWithKeyType = {
  ...$Exact<EnabledFeaturesType>,
  featureKey: string,
};

const optimizely = createInstance({
  sdkKey: conf.OPTIMIZELY_SDK_KEY,
});

export const getEnabledFeatures = ({ userId, attributes }: EnabledFeaturesType) =>
  optimizely
    .onReady()
    .then(() => Promise.resolve(optimizely.getEnabledFeatures(userId, attributes)));

export const isFeatureEnabled = ({ featureKey, userId, attributes }: EnabledFeatureWithKeyType) =>
  optimizely
    .onReady()
    .then(() => Promise.resolve(optimizely.isFeatureEnabled(featureKey, userId, attributes)));
